import { Component, Input } from '@angular/core';

@Component({
    selector: 'qc-header',
    standalone: true,
    imports: [],
    template: `
        <div
            class="border-b-1 border-neutral-150 shadow-qc px-10 py-8 flex justify-between bg-white z-999"
            [class.sticky]="sticky"
            [class.fixed]="fixed"
            [class.top-0]="sticky || fixed"
            [class.right-0]="fixed"
            [class.left-64]="fixed"
        >
            <h1 class="text-3xl font-bold">{{ title }}</h1>
            <ng-content></ng-content>
        </div>
    `,
})
export class HeaderComponent {
    @Input() title: string = '';
    @Input() sticky: boolean = false;
    @Input() fixed: boolean = false;
}
